import { DateTime } from 'luxon'
import { useEffect, useRef, useState } from 'react'

type CountdownProps = {
    startedAt: Date
    maxDurationMs: number
    onEnd: () => unknown
}

export function Countdown({ startedAt, maxDurationMs, onEnd }: CountdownProps) {
    const endTimeDate = DateTime.fromJSDate(startedAt).plus(maxDurationMs)

    const calculateTimeLeft = (endTimeDate: DateTime) => {
        return endTimeDate.diff(DateTime.now())
    }

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(endTimeDate))

    const intervalRef = useRef<NodeJS.Timer | undefined>()
    useEffect(() => {
        const fn = () => {
            const timeLeft = calculateTimeLeft(endTimeDate)

            if (timeLeft.as('seconds') > 0) {
                setTimeLeft(timeLeft)
                return
            }

            clearInterval(intervalRef.current)
            onEnd()
        }

        intervalRef.current = setInterval(fn, 1000)
        return () => clearInterval(intervalRef.current)
    }, [endTimeDate, onEnd])

    const moreThanOneHourLeft = timeLeft.as('hours') >= 1
    const format = moreThanOneHourLeft ? 'hh:mm:ss' : 'mm:ss'
    const suffix = moreThanOneHourLeft ? 'h' : 'min'

    return (
        <>
            {timeLeft.toFormat(format)}&nbsp;{suffix}
        </>
    )
}
